import tw, { styled } from "twin.macro"
import { useState } from "react"
import { NavLink, Outlet, useLocation } from "react-router-dom"
import { ReactComponent as Hamburger } from "./assets/hamburger.svg"
import { ReactComponent as Close } from "./assets/close.svg"
import isMobileCheck from "./utils/isMobileCheck"

export default function App() {
  const [menu, setMenu] = useState(false)
  const location = useLocation()
  const isHome = location.pathname === "/"

  const toggleMenu = bool => setMenu(now => bool || !now)

  return (
    <Wrapper>
      <NavBar isHome={isHome}>
        <Title isHome={isHome}>OpenAI API</Title>
        {isHome ? (
          <>
            <Link to="/text">Text</Link>
            <Link to="/image">Image</Link>
            <Link to="/voice">Voice</Link>
          </>
        ) : (
          <>
            <MobileButton onClick={() => toggleMenu()}>
              {menu ? <Close /> : <Hamburger />}
            </MobileButton>

            <Menu open={menu} isMobile={isMobileCheck()}>
              <Link to="/" onClick={() => toggleMenu(false)}>
                Home
              </Link>
              <Link to="/text" onClick={() => toggleMenu(false)}>
                Text
              </Link>
              <Link to="/image" onClick={() => toggleMenu(false)}>
                Image
              </Link>
              <Link to="/voice" onClick={() => toggleMenu(false)}>
                Voice
              </Link>
            </Menu>
          </>
        )}
      </NavBar>
      <Outlet />
    </Wrapper>
  )
}

const Wrapper = tw.div`fixed w-screen h-screen bg-neutral-800 text-white overflow-y-auto`
const Title = styled.h1(({ isHome }) => [
  tw`text-4xl font-bold `,
  isHome && tw`text-5xl mb-10`,
])
const NavBar = styled.nav(({ isHome }) => [
  tw`flex justify-center bg-neutral-700 items-center py-4 gap-4 text-base md:(text-xl justify-between px-10)`,
  isHome &&
    tw`flex-col gap-5 h-screen bg-neutral-800 text-2xl pb-32 justify-center items-center md:justify-center`,
])
const MobileButton = tw.button`[& > svg]:(w-10 h-10) fixed top-4 right-4 md:hidden z-10`
const Menu = styled.div(({ open, isMobile }) => [
  tw`pt-10 px-10 flex flex-col gap-4 fixed bottom-0 left-0 w-full h-[calc(100vh - 70px)] bg-neutral-700 text-2xl md:(w-auto p-0 static flex-row items-center justify-center gap-0 h-auto) transition-all duration-300 ease-in-out`,
  isMobile && tw`h-[calc(90vh - 70px)]`,
  open ? tw`translate-x-0` : tw`translate-x-full`,
  tw`md:(translate-x-0 flex flex-row items-center gap-5 duration-[0ms])`,
])
const Link = tw(
  NavLink
)`bg-neutral-900 py-2 px-4 md:(py-4 px-4) min-w-[7rem] text-center rounded-xl font-bold hover:(scale-[102%] shadow-xl) transition-all duration-300 ease-in-out transform`
